module.exports = __webpack_public_path__ + "img/empty.e8bfed1f.png";